import "./App.css";
import { Container, createTheme, Stack, ThemeProvider } from "@mui/material";
import SearchBar from "./sections/SearchBar";
import Body from "./sections/Body";
import { useEffect, useState } from "react";
import useHttp from "./util/use-http";
import AlertSnackBar from "./ui/AlertSnackBar";
import { useLocation } from "react-router-dom";

const DATA_PER_PAGE = 10;

const theme = createTheme({
  typography: {
    fontFamily: "inherit",
  },
  palette: {
    primary: {
      main: "#1067B1",
    },
    yellow: {
      main: "#F8BF02",
      contrastText: "#1067B1",
    },
    white: {
      main: "#ffffff",
      contrastText: "#ffffff",
    },
  },
});

function App() {
  const [branches, setBranches] = useState([]);

  const location = useLocation();

  const {
    isLoading,
    error,
    sendRequest: getBranches,
    setErrorNull,
  } = useHttp();

  const fetchBranches = () => {
    getBranches(
      {
        url: "/wp-json/wcd/v1/branches",
        method: "POST",
        body: {
          query: location.search,
        },
      },
      (res) => {
        if (res.code === "success") {
          setBranches(res.data);
        }
      }
    );
  };

  useEffect(() => {
    fetchBranches();
  }, [location.search]);

  const onSearchCLickHandler = () => {
    fetchBranches();
  };

  return (
    <ThemeProvider theme={theme}>
      <Container>
        <Stack spacing={2}>
          <SearchBar onSearch={onSearchCLickHandler} />
          <Body
            branches={branches}
            loading={isLoading}
            dataPerPage={DATA_PER_PAGE}
          />
          <AlertSnackBar
            type="error"
            open={!!error}
            message={error}
            closeSnackBar={() => {
              setErrorNull(null);
            }}
          />
        </Stack>
      </Container>
    </ThemeProvider>
  );
}

export default App;
